(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apollo-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.apollo-header-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-apollo-drawer-close]');
    if (!closeButton) return;

    const details = closeButton.closest('details');
    const summary = details?.querySelector('summary');
    if (summary) summary.click();
  });

  /* Hover-to-open mega menu on desktop / laptop only */
  (function () {
    const desktop = window.matchMedia('(min-width: 990px)');
    const items = document.querySelectorAll('.apollo-header__nav-item--mega');
    if (!items.length) return;

    const closeAll = (except) => {
      items.forEach((item) => {
        if (item === except) return;
        const d = item.querySelector('.apollo-header__dropdown');
        if (d) d.removeAttribute('open');
      });
    };

    items.forEach((item) => {
      const details = item.querySelector('.apollo-header__dropdown');
      if (!details) return;
      let closeTimer;

      const open = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        details.setAttribute('open', '');
      };

      const scheduleClose = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => details.removeAttribute('open'), 160);
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) scheduleClose();
      });

      /* Clicking the top-level label navigates to its link instead of just
         toggling the mega menu (the caret still toggles; hover still opens). */
      const label = details.querySelector('.apollo-header__nav-link-label');
      if (label) {
        label.addEventListener('click', (event) => {
          const href = label.getAttribute('href');
          if (href && href !== '#') {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = href;
          }
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-help"] && !Shopify.designMode) return;
  try {
    
  class ApolloHelpShowcase extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-help-card]')];
      this.slides = [...this.querySelectorAll('[data-help-slide]')];
      this.activeIndex = this.cards.findIndex((card) => card.classList.contains('is-active'));
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.cards.forEach((card, index) => {
        card.addEventListener('click', () => this.setActive(index));
      });

      this.blockSelectHandler = (event) => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('[data-help-card]');
        if (!card) return;
        const index = Number(card.dataset.helpCard);
        if (!Number.isNaN(index)) this.setActive(index);
      };

      document.addEventListener('shopify:block:select', this.blockSelectHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.blockSelectHandler);
    }

    setActive(index) {
      if (!this.cards.length || index === this.activeIndex) return;

      this.activeIndex = index;

      this.cards.forEach((card, i) => {
        const isActive = i === index;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
    }
  }

  if (!customElements.get('apollo-help-showcase')) {
    customElements.define('apollo-help-showcase', ApolloHelpShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-landing-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('ApolloLandingFaq-{{ section.id }}');
    if (!section) return;

    const list = section.querySelector('[data-lfaq-list]');
    if (!list) return;

    const items = [...list.querySelectorAll('.apollo-lfaq__item')];
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-landing-glance"] && !Shopify.designMode) return;
  try {
    
  class ApolloGlanceGrid extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-glance-play]');
        if (!button) return;

        const media = button.closest('.apollo-glance__media');
        const video = media && media.querySelector('video');
        if (!video) return;

        media.classList.add('is-playing');
        video.setAttribute('controls', 'controls');

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    }
  }

  if (!customElements.get('apollo-glance-grid')) {
    customElements.define('apollo-glance-grid', ApolloGlanceGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
